import React, { useEffect, useRef, useState, version } from "react";
import { Card, Dimmer, Grid, Icon, Loader } from "semantic-ui-react";
import {
  apiGetVersionHistoryDetails,
  apiGetVersionHistoryList,
} from "./myResources.api";
import { showErrorToast } from "../../utils/toastUtils";
import { formatDateTime } from "../../utils/utils";
import sampleFeature from "../../assets/images/sample-feature.png";
import Markdown from "react-markdown";
import DotsPagination from "../../components/DotsPagination";
import newIcon from "../../assets/images/icons/new_icon.png";
import changedIcon from "../../assets/images/icons/changed_icon.png";
import fixedIcon from "../../assets/images/icons/fixed_icon.png";

const VersionHistoryList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [listLoading, setListLoading] = useState(true);
  const [versionHistoryList, setVersionHistoryList] = useState([]);
  const [selectedId, setSelectedId] = useState(0);
  const [selectedVersion, setSelectedVersion] = useState({});
  const [versionDetails, setVersionDetails] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 1;
  const totalItems = versionDetails.length;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentVersionDetails = versionDetails.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getVersionHistoryList();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, []);

  useEffect(() => {
    if (selectedId) {
      const delayDebounceFn = setTimeout(() => {
        getVersionHistoryDetails();
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [selectedId]);

  const getVersionHistoryDetails = async () => {
    setIsLoading(true);
    try {
      const result = await apiGetVersionHistoryDetails(selectedId);
      if (result) {
        setVersionDetails(JSON.parse(result.markdownText));
        setIsLoading(false);
      }
    } catch (error) {
      showErrorToast("Failed to get resources. Please try again.");
      setIsLoading(false);
    }
  };

  const getVersionHistoryList = async () => {
    setListLoading(true);
    try {
      const result = await apiGetVersionHistoryList();
      if (result) {
        setVersionHistoryList(
          result.versionHistoryList ? result.versionHistoryList : []
        );
        setSelectedVersion(result.versionHistoryList[0]);
        setSelectedId(result.versionHistoryList[0].id);
        setListLoading(false);
      }
    } catch (error) {
      showErrorToast("Failed to get resources. Please try again.");
      setListLoading(false);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <Grid
        columns={2}
        divided
        className="order-management"
        style={{ marginTop: 20 }}
      >
        <Grid.Column
          width={4}
          className="inventory-list-section"
          style={{ height: 600, paddingTop: 0, paddingRight: 15 }}
        >
          <div className="order-list" style={{ paddingBottom: 50 }}>
            <div style={{ position: "absolute", top: 150, left: 140 }}>
              {listLoading ? (
                <Loader
                  active
                  className="workaround"
                  size="large"
                  inline="centered"
                />
              ) : null}
            </div>
            <div style={{ paddingLeft: "1rem", paddingBottom: 10 }}>
              <span
                style={{ fontSize: 24, color: "#66cc23", fontWeight: "bolder" }}
              >
                Versions
              </span>
            </div>
            <div
              className="inventory-list-scroll"
              disabled={listLoading}
              style={{ opacity: listLoading ? 0.2 : 1, paddingTop: 5 }}
            >
              {versionHistoryList?.map((data) => {
                return (
                  <Card
                    className={
                      selectedId === data?.id ? "job-card active" : "job-card"
                    }
                    style={{
                      cursor: "default",
                      minHeight: 65,
                      minWidth: 185,
                      borderRadius: 10,
                      marginBottom: "0px !important",
                      boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.3)",
                      position: "relative", // Ensure relative positioning
                      cursor: "pointer",
                    }}
                  >
                    <Card.Content
                      style={{
                        minHeight: 60,
                        paddingTop: 25,
                        paddingBottom: 20,
                        paddingRight: 20,
                      }}
                      onClick={() => {
                        if (selectedId !== data?.id) {
                          setCurrentPage(1);
                          setIsLoading(true);
                          setVersionDetails([]);
                          setSelectedId(data?.id);
                          setSelectedVersion(data);
                        } else {
                          setVersionDetails([]);
                          setSelectedId(0);
                          setSelectedVersion(null);
                        }
                      }}
                    >
                      <Grid>
                        <Grid.Column
                          width={16}
                          style={{
                            padding: 0,
                            paddingLeft: 15,
                            paddingRight: 10,
                          }}
                        >
                          <div>
                            <h3>Version {data?.versionNumber}</h3>
                          </div>
                          <div style={{ paddingTop: 5 }}>
                            <span
                              style={{
                                fontSize: 14,
                                color: "#66CC23",
                                fontWeight: "bolder",
                              }}
                            >
                              {data?.description}
                            </span>
                          </div>
                          <div style={{ paddingTop: 15, textAlign: "right" }}>
                            <span style={{ fontSize: 12 }}>
                              {formatDateTime(data?.releaseDateTime, false)}
                            </span>
                          </div>
                        </Grid.Column>
                      </Grid>
                    </Card.Content>
                  </Card>
                );
              })}
            </div>
          </div>
        </Grid.Column>
        <Grid.Column width={12} style={{ paddingRight: 0 }}>
          {isLoading || !selectedVersion?.id ? (
            <Dimmer active inverted>
              <div style={{ position: "absolute", top: 150, left: 350 }}>
                {isLoading ? (
                  <Loader
                    active
                    className="workaround"
                    size="large"
                    inline="centered"
                  />
                ) : null}
              </div>
            </Dimmer>
          ) : null}
          {selectedVersion?.id && versionDetails.length > 0 ? (
            <div
              style={{ height: 510, overflowX: "hidden", overflowY: "scroll" }}
            >
              <Grid style={{ padding: 20 }}>
                <Grid.Column width={16} style={{ paddingTop: 0 }}>
                  <div>
                    <span
                      style={{
                        fontSize: 26,
                        fontWeight: "bolder",
                        color: "#66cc23",
                      }}
                    >
                      {selectedVersion.description}
                    </span>
                  </div>
                  <div style={{ paddingBottom: 20 }}>
                    <span
                      style={{
                        fontSize: 16,
                        color: "#AFABAB",
                      }}
                    >
                      {selectedVersion.versionNumber
                        ? `v${selectedVersion.versionNumber}`
                        : ""}
                    </span>
                  </div>
                  <div>
                    {currentVersionDetails.map((data, index) => (
                      <div style={{ paddingBottom: 15 }} key={index}>
                        <h3
                          style={{
                            borderBottom: "1px solid #d1d9e0b3",
                            paddingTop: 5,
                            paddingBottom: ".3em",
                            color: "#66CC23",
                          }}
                        >
                          <img
                            src={
                              data.title === "New"
                                ? newIcon
                                : data.title === "Changed"
                                ? changedIcon
                                : fixedIcon
                            }
                            style={{
                              marginTop: -4.5,
                              width: 25,
                              height: "auto",
                              marginRight: 8,
                            }}
                          />
                          {data.title}
                        </h3>
                        <Markdown
                          components={{
                            img: ({ node, ...props }) => (
                              <img
                                {...props}
                                style={{
                                  maxWidth: "40%",
                                  height: "auto",
                                  display: "block",
                                }}
                                alt={props.alt}
                              />
                            ),
                          }}
                        >
                          {data.content}
                        </Markdown>
                      </div>
                    ))}
                  </div>
                </Grid.Column>
              </Grid>
            </div>
          ) : (
            <div style={{ height: 300 }}></div>
          )}
          <div style={{ marginLeft: "auto", marginRight: "auto" }}>
            {isLoading ? null : (
              <DotsPagination
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default VersionHistoryList;
